import { alpha } from '@mui/material/styles';

export function subtleSurfaceBg(theme) {
  return theme.palette.mode === 'dark'
    ? alpha(theme.palette.common.white, 0.04)
    : theme.palette.grey[50];
}

export function mutedSurfaceBg(theme) {
  return theme.palette.mode === 'dark'
    ? alpha(theme.palette.common.white, 0.06)
    : theme.palette.grey[100];
}

export function primarySoftSurfaceBg(theme) {
  return theme.palette.mode === 'dark'
    ? alpha(theme.palette.primary.main, 0.16)
    : theme.palette.primary.light;
}
